import axios from "axios";
import Utils from '../utilities';
import { API_ROOT } from '../config';

axios.interceptors.request.use(
  config => {
    let token = Utils.authToken();
    if(token){
      config.headers['Authorization'] = `Bearer ${token}`;
    }else{
      delete axios.defaults.headers.common["Authorization"];
    }
    return config;
  }
)

axios.interceptors.response.use(
  response => {
    return response;
  },
  async error => {
    let elem = document.querySelector('.login-card');
    let accElem = document.querySelector('.access-card');
    if(error.response?.status === 401){
      error.response?.data?.message !== "expired" ? redirectToLogin() : elem && elem.classList.remove('d-none');
    }
    else if(error.response?.status === 403){
      // alert("You do not have permission");
      // accElem && accElem.classList.remove('d-none')
    }
    return Promise.reject(error);
  }
);

const redirectToLogin = () => {
    Utils.setStoredValue('resp',null);
    window.location.reload();
} 



const http = {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  patch: axios.patch,
  delete: axios.delete,
};

export default http;
